import { setupWorker } from 'msw/browser'

import { handlers } from './handlers'

export const worker = setupWorker(...handlers)

// Start the worker conditionally
export const startMocking = async () => {
  if (import.meta.env.VITE_ENABLE_MSW === 'true') {
    return worker.start({
      onUnhandledRequest: 'bypass',
    })
  }
}

export { handlers } from './handlers'
